var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app_wrapper"},[_c('nav-header',{ref:"navHeader",staticClass:"app_header"}),_c('el-scrollbar',{ref:"appMain",staticClass:"app_main"},[_c('app-main')],1),(_vm.$route.path!='/about')?_c('ys-aside-right'):_vm._e(),_c('announcement-notice',{ref:"announcementNotice"}),_c('ys-register-popup',{attrs:{"rf":"ysRegisterPopup"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }